<template>
  <div id="AuthorizedPickupListDetailsReport">
    <div class="container admin-wrap mt-5">
      <div class="row header mb-3">
        <div class="col-lg-8">
          <h3 class="text-left">Authorized Pickup List Details Report</h3>
        </div>
        <div class="col-lg-4 divSelection">
          <el-button v-if="!isEmpty" type="primary" round @click="exportExcel()" class="btnExport"
            ><i class="fa fa-file-excel-o" aria-hidden="true"></i> Export</el-button
          >
        </div>
      </div>

      <div class="pb-5">
        <div class="empty-list_image" v-if="isEmpty">
          <strong>{{ startupText }}</strong>
          <img src="../assets/notfound.png" />
        </div>

        <div v-if="!isEmpty" class="datatable_group">
          <el-row :gutter="10" class="mb-3">
            <el-col :span="8">
              <el-input v-model="authorizedPickupListFilters[0].value" placeholder="Search Student ID"></el-input>
            </el-col>
            <el-col :span="8">
              <el-input v-model="authorizedPickupListFilters[1].value" placeholder="Search Student Name"></el-input>
            </el-col>
            <el-col :span="8">
              <el-input v-model="authorizedPickupListFilters[2].value" placeholder="Search Class Name"></el-input>
            </el-col>
          </el-row>

          <data-tables :data="authorizedPickupListInt" :filters="authorizedPickupListFilters">
            <el-table-column
              v-for="authorizedPickupInfo in authorizedPickupList"
              :prop="authorizedPickupInfo.prop"
              :label="authorizedPickupInfo.label"
              :key="authorizedPickupInfo.prop"
              sortable="custom"
            >
            </el-table-column>
          </data-tables>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataSource from '../data/datasource'
import XLSX from 'xlsx'
import Cookies from 'js-cookie'

export default {
  name: 'AuthorizedPickupListDetailsReport',
  async mounted() {
    await this.loadAuthorizedPickupListDetailsReport()
  },
  data() {
    return {
      startupText: 'No Record...',
      authorizedPickupListInt: [],
      authorizedPickupListFilters: [
        {
          value: '',
          prop: 'Index_No',
        },
        {
          value: '',
          prop: 'Full_Name',
        },
        {
          value: '',
          prop: 'CLS_ClassName',
        },
      ],
      authorizedPickupList: [
        {
          prop: 'Index_No',
          label: 'Student ID',
        },
        {
          prop: 'Student_Name',
          label: 'Student Name',
        },
        {
          prop: 'Status',
          label: 'Status',
        },
        {
          prop: 'CLS_ClassName',
          label: 'Class Name',
        },
        {
          prop: 'AutPickName',
          label: 'Authorized Pickup Person',
        },
        {
          prop: 'AutPickRelationship',
          label: 'Relationship',
        },
        {
          prop: 'AutPickContactNo',
          label: 'Contact No',
        },
      ],
    }
  },
  computed: {
    isEmpty() {
      return this.authorizedPickupListInt.length < 1
    },
  },
  methods: {
    async loadAuthorizedPickupListDetailsReport() {
      this.$vs.loading()

      this.authorizedPickupListInt = []

      try {
        const response = await DataSource.shared.getAuthorizedPickupListDetailsReport(Cookies.get('schoolSession'))
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '99') {
            this.$notify.error({
              title: 'Error',
              message: 'Error',
            })
          } else if (response.code === '2') {
            this.$notify({
              title: 'No Record',
              message: 'No Record Found',
            })
          } else {
            this.authorizedPickupListInt = response
          }
        }
      } catch (e) {
        this.results = e
      }

      this.$vs.loading.close()
    },
    exportExcel() {
      let exportExcelObject = []

      this.authorizedPickupListInt.forEach(m => {
        let temp = {
          'Student ID': m.Index_No,
          'Student Name': m.Full_Name,
          Status: m.Status,
          'Class Name': m.CLS_ClassName,
          'Authorized Pickup Person': m.AutPickName,
          Relationship: m.AutPickRelationship,
          'Contact No': m.AutPickContactNo,
        }

        exportExcelObject.push(temp)
      })

      var sheet1WS = XLSX.utils.json_to_sheet(exportExcelObject)
      var wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, sheet1WS, 'sheet1')
      XLSX.writeFile(wb, 'Authorized Pickup List Details Report.xlsx')
    },
  },
}
</script>

<style scoped>
.divSelection {
  text-align: right;
}
</style>
